const pagination2 = {
  data() {
    return {
      pageNo2: 1,
      pageSize2: 20,
      totalAmount2: 0,
      fetchDataHandlerName2: null,
    }
  },

  computed: {
    // 总页数
    totalPages2() {
      return Math.ceil(this.totalAmount2 / this.pageSize2)
    },
  },

  methods: {
    /**
     * 初始化 List
     * @param fetchDataHandler 组件自身定义的获取后端数据的方法名称
     * @param [doFetch] 是否需要立即请求数据，默认：是
     * 业务组件自定义该函数，方便传递不同的参数，也方便处理不同的 loading 效果
     */
    initPagination2(fetchDataHandler, doFetch = true) {
      if (doFetch) {
        this[fetchDataHandler]()
      }

      // 存储获取数据的方法名称
      this.fetchDataHandlerName2 = fetchDataHandler
    },

    // 翻页操作后获取数据：组件如需自定义，可覆盖
    handlePageNoChange2() {
      if (this.fetchDataHandlerName2) {
        this[this.fetchDataHandlerName2]()
      }
    },
  },
}

export default pagination2
